import { bool, func, node, number, oneOf, oneOfType, shape, string } from 'prop-types';
import { Button } from '@fiverr-private/fit';

export const uploadButton = {
    className: string,
    multiple: bool,
    isDisabled: bool,
    size: oneOf(Object.values(Button.SIZES)),
    color: oneOf(Object.values(Button.COLORS)),
    title: oneOfType([string, node]),
    showTitle: bool,
    icon: func,
    filesLimit: number,
    onUpload: func,
    onClick: func
};

export const filerrUploaderOptions = shape({
    objectName: string.isRequired,
    attachmentName: string.isRequired,
    getPolicyUrl: string.isRequired,
    createPendingAttachmentIdUrl: string.isRequired,
    shouldBeRenamed: bool
});
